/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateShareStatusDto
 */
export interface UpdateShareStatusDto {
    /**
     * Whether the exported chat is shared with the provider
     * @type {boolean}
     * @memberof UpdateShareStatusDto
     */
    isSharedWithProvider: boolean;
}

/**
 * Check if a given object implements the UpdateShareStatusDto interface.
 */
export function instanceOfUpdateShareStatusDto(value: object): value is UpdateShareStatusDto {
    if (!('isSharedWithProvider' in value) || value['isSharedWithProvider'] === undefined) return false;
    return true;
}

export function UpdateShareStatusDtoFromJSON(json: any): UpdateShareStatusDto {
    return UpdateShareStatusDtoFromJSONTyped(json, false);
}

export function UpdateShareStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateShareStatusDto {
    if (json == null) {
        return json;
    }
    return {
        
        'isSharedWithProvider': json['isSharedWithProvider'],
    };
}

export function UpdateShareStatusDtoToJSON(json: any): UpdateShareStatusDto {
    return UpdateShareStatusDtoToJSONTyped(json, false);
}

export function UpdateShareStatusDtoToJSONTyped(value?: UpdateShareStatusDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isSharedWithProvider': value['isSharedWithProvider'],
    };
}

